import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import appStoreBadge from '../assets/app-store-badge.svg';
import playStoreBadge from '../assets/play-store-badge.png';

export default function InstallRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const campaign = params.get('campaign') || '';

  const [platform, setPlatform] = useState<'ios'|'android'|'other'>('other');

  useEffect(() => {
    const ua = navigator.userAgent || '';

    if (campaign) {
      localStorage.setItem('campaign_code', campaign);
    }

    if (/iPhone|iPad|iPod/.test(ua)) {
      setPlatform('ios');
    } else if (/Android/.test(ua)) {
      setPlatform('android');
      window.location.href = `https://play.google.com/store/apps/details?id=com.letspoll.apm&referrer=${campaign}`;
    } else {
      setPlatform('other');
    }
  }, [campaign]);

  async function handleContinueToAppStore() {
    try {
      await navigator.clipboard.writeText(campaign);
      console.log('Campaign copied to clipboard:', campaign);
    } catch (err) {
      console.error('Clipboard copy failed:', err);
    }

    window.location.href = `https://apps.apple.com/us/app/american-polling-machine/id6670273172?pt=${campaign}`;
  }

  const iosUrl = `https://apps.apple.com/us/app/american-polling-machine/id6670273172?pt=${campaign}`;
  const androidUrl = `https://play.google.com/store/apps/details?id=com.letspoll.apm&referrer=${campaign}`;

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      {platform === 'ios' && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleContinueToAppStore}
        >
          Continue to App Store
        </Button>
      )}

      {platform === 'other' && (
        <>
          <Typography variant="h2" gutterBottom
            sx={{ fontFamily: 'Jancient, sans-serif', textAlign: 'center' }}>
            APM App on iOS or Android
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <Button
              component="a"
              href={iosUrl}
              target="_blank"
              rel="noopener"
              sx={{ p: 0 }}
            >
              <img
                src={appStoreBadge}
                alt="Download on the App Store"
                style={{ height: 60 }}
              />
            </Button>
            <Button
              component="a"
              href={androidUrl}
              target="_blank"
              rel="noopener"
              sx={{ p: 0 }}
            >
              <img
                src={playStoreBadge}
                alt="Get it on Google Play"
                style={{ height: 60 }}
              />
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}
